import { inject } from '@angular/core';
import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';

export const SKIP_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

const GENERIC_ERROR_MESSAGE =
  'Something went wrong. Please try again, or contact IT support if the issue persists.';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);

  if (req.context.get(SKIP_ERROR_INTERCEPTOR)) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        toastr.error(GENERIC_ERROR_MESSAGE, 'Something went wrong.');
      }
      return throwError(() => error);
    }),
  );
};
